import { VehicleSize } from 'api';
import { DEFAULT_LANGUAGE } from 'constants/language';
import trimAllSpaces from 'utils/text/trimAllSpaces';
import isHeavyVehicle from 'utils/vehicle/isHeavyVehicle';
export const mapIObeIdWithVehicleToIVehicle = vehicle => {
  const mappedVehicle = {
    brand: vehicle.brand,
    euClass: vehicle.euClass,
    registrationNumber: vehicle.registrationNumber,
    nationality: vehicle.registrationCountryCode,
    size: vehicle.size,
    model: vehicle.model,
    isMobileHome: vehicle.isMobileHome,
    kuId: vehicle.kuId
  };
  return mappedVehicle;
};
export const mapVehicleToIVehicle = vehicle => {
  const mappedVehicle = {
    ...vehicle,
    firstRegistrationDate: vehicle.createdOn,
    nationality: vehicle.registrationCountryCode,
    kuId: vehicle.kuId
  };
  return mappedVehicle;
};
export const mapGetVehicleInformationResponseToIVehicleInformation = vehicle => {
  const mappedVehicle = {
    isOwner: vehicle.isOwner,
    color: vehicle.color,
    brand: vehicle.carMake,
    model: vehicle.carModel,
    registrationNumber: vehicle.carPlate,
    nationality: DEFAULT_LANGUAGE,
    fuelType: vehicle.fuelTypeCode,
    euClass: vehicle.euCode,
    weight: vehicle.weight,
    classification: vehicle.technicalCode,
    technicalCode: vehicle.technicalCode,
    fuelTypeCode: vehicle.fuelTypeCode,
    hybridCategory: vehicle.hybridCategory,
    modelYear: vehicle.firstRegistrationDate,
    size: vehicle.weight && isHeavyVehicle(vehicle.weight) ? VehicleSize.Heavy : VehicleSize.Regular,
    isMobileHome: vehicle.isMobileHome,
    kuId: vehicle.kuId
  };
  return mappedVehicle;
};
export const mapGetObeDetailsResult = vehicle => {
  if (!vehicle) return undefined;
  const mappedVehicle = {
    brand: vehicle.brand,
    classification: vehicle.classification,
    euClass: vehicle.euClass,
    nationality: vehicle.nationality,
    registrationNumber: vehicle.registrationNumber,
    size: vehicle.size,
    agreementName: vehicle.agreementName,
    model: vehicle.model,
    isMobileHome: vehicle.isMobileHome,
    kuId: vehicle.kuId
  };
  return mappedVehicle;
};
export const mapIVehicleToRegisterVehicle = vehicle => {
  if (!vehicle) return vehicle;
  const mappedVehicle = {
    registrationNumber: trimAllSpaces(vehicle.registrationNumber),
    nationality: vehicle.nationality,
    brand: vehicle.brand,
    model: vehicle.model,
    color: vehicle.color,
    classification: vehicle.classification,
    size: vehicle.size,
    chargeable: false,
    euClass: vehicle.euClass,
    fuelType: vehicle.fuelType,
    modelYear: vehicle.modelYear,
    isMobileHome: vehicle.isMobileHome,
    kuId: vehicle.kuId
  };
  return mappedVehicle;
};
export const mapVehicleForm = (values, chosenCountry) => ({
  brand: values.brand,
  chargeable: false,
  nationality: chosenCountry,
  classification: values.classification,
  euClass: values.euClass,
  fuelType: values.fuelType,
  color: values.color,
  model: values.model,
  registrationNumber: values.registrationNumber,
  size: values.size,
  modelYear: parseInt(values.modelYear, 10) ? new Date(parseInt(values.modelYear, 10), 1, 1) : new Date(1, 1, 1),
  // Swagger type is Date
  isMobileHome: values.isMobileHome,
  kuId: values.kuId
});
export const mapIVehicleToVehicleForm = vehicle => {
  if (!vehicle) return null;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return {
    ...vehicle,
    chargeable: vehicle.chargeable?.toString() ?? 'false',
    modelYear: new Date(vehicle?.modelYear).getFullYear().toString() ?? ''
  };
};